import React, {useEffect, useState} from 'react';
import PaymentLinks from './payment_links/payment_links';
import Flash_checkout from './flash_checkout/flash_checkout';

export default function PaymentLinkNavigator(){
    const [type, setType] = useState('');
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const type = urlParams.get('type');
        setType(type);
    }, []);
    return <>{type==="new"?<PaymentLinks/>:<Flash_checkout/>}</>
}
